export enum TierEnum {
  // Legacy plans (existing subscribers only, not buyable).
  LEGACY_LITE = 'legacy_lite',
  LEGACY_ADDONS = 'legacy_addons',
  TRIAL = 'trial',
  BASIC = 'basic',
  ESSENTIAL = 'essential',
  PROFESSIONAL = 'professional',
  BUSINESS = 'business',
  CUSTOM = 'custom',
  // New pricing (AI credits). CUSTOM is reused as "Enterprise".
  FREE = 'free',
  STARTER = 'starter',
  BASIC_2026 = 'basic_2026',
  ESSENTIAL_2026 = 'essential_2026',
  PROFESSIONAL_2026 = 'professional_2026',
  BUSINESS_2026 = 'business_2026',
}
